import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  IconButton,
  makeStyles,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CropFreeIcon from "@material-ui/icons/CropFree";
import PeopleIcon from "@material-ui/icons/People";
import RemoveIcon from "@material-ui/icons/Remove";
import QRCode from "qrcode.react";
import React, { useCallback, useState } from "react";
import QrReader from "react-qr-reader";
import SwipeableViews from "react-swipeable-views";
import TabPanel from "../TabPanel";
import useSeat from "./useSeat";
interface BeachSelectorDialogProps {
  beachId: string;
  maxPeople: number;
  selectedSeat?: {
    progressiveNumber: number;
    row: number;
  };
  isOpen: boolean;
  onClose: () => void;
}

const useStyles = makeStyles((theme) => ({
  counter: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center;",
  },
  title: {
    textAlign: "center",
    width: "100%",
    padding: theme.spacing(1),
  },
  qr: {
    textAlign: "center",
    marginTop: theme.spacing(2),
    "& > section": {
      margin: "auto",
    },
  },
  checkbox: {
    textAlign: "center",
  },
  inputForm: {
    display: "block",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    justifyContent: "center",
    "& .MuiFormControl-root": {
      marginBottom: theme.spacing(2),
    },
  },
  addButton: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  divider: {
    margin: 0,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));

const BeachSelectorDialog: React.FC<BeachSelectorDialogProps> = ({
  isOpen = false,
  onClose = () => {},
  selectedSeat,
  beachId,
  maxPeople,
}) => {
  const classes = useStyles();
  const {
    handleDeleteSeat,
    handleSeat,
    handleNumberOfSeats,
    selectedSeatMaxReservations,
    seat,
  } = useSeat({
    selectedSeat,
    beachId,
    maxPeople,
  });
  const [value, setValue] = useState(0);
  const [isManual, setIsManual] = useState(false);
  const theme = useTheme();

  const handleDownloadQr = ({ currentTarget }: any) => {
    const link = document.createElement("a");
    link.download = "qr.png";
    link.href = currentTarget?.toDataURL();
    link.click();
  };

  const onAddSeat = useCallback(() => {
    handleSeat(selectedSeatMaxReservations, seat?.id);
  }, [handleSeat, seat, selectedSeatMaxReservations]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index: number) => {
    setValue(index);
  };

  const handleManualInsert = () => {
    setIsManual((old) => !old);
  };

  function a11yProps(index: any) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }
  return (
    <Dialog
      fullWidth
      open={isOpen}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        Modifica posto {selectedSeat?.progressiveNumber}, fila{" "}
        {selectedSeat?.row}
      </DialogTitle>
      <DialogContent>
        <div className={classes.title}>Numero massimo di persone</div>
        <div className={classes.counter}>
          <Typography variant="h2">{selectedSeatMaxReservations}</Typography>
          <div>
            <div>
              <IconButton
                onClick={handleNumberOfSeats(1)}
                color="primary"
                size="small"
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </div>
            <div>
              <IconButton
                onClick={handleNumberOfSeats(-1)}
                color="secondary"
                size="small"
              >
                <RemoveIcon fontSize="small" />
              </IconButton>
            </div>
          </div>
        </div>

        <DialogContentText>
          <div className={classes.checkbox}>
            <FormControlLabel
              value="end"
              control={<Checkbox color="primary" />}
              onChange={!!seat?.id ? handleDeleteSeat : onAddSeat}
              label="Prenotabile"
              labelPlacement="end"
              checked={!!seat?.id}
            />
          </div>
          <div>
            {seat?.id && (
              <>
                <Divider className={classes.divider} variant="middle" />

                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                >
                  <Tab
                    icon={<PeopleIcon />}
                    label="Nominativi"
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={<CropFreeIcon />}
                    label="QR Posto"
                    {...a11yProps(1)}
                  />
                </Tabs>
                <SwipeableViews
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={value}
                  onChangeIndex={handleChangeIndex}
                >
                  <TabPanel value={value} index={0} dir={theme.direction}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isManual}
                          onChange={handleManualInsert}
                          name="checkedB"
                          color="primary"
                        />
                      }
                      label="Inserimento manuale"
                    />
                    {isManual ? (
                      <div className={classes.inputForm}>
                        <TextField
                          fullWidth
                          id="standard-basic"
                          label="Nome e cognome"
                        />
                        <Button
                          fullWidth
                          startIcon={<AddIcon></AddIcon>}
                          color="primary"
                          variant="contained"
                        >
                          Aggiungi
                        </Button>
                      </div>
                    ) : (
                      <div className={classes.qr}>
                        <QrReader
                          delay={300}
                          onError={console.log}
                          onScan={console.log}
                          style={{ width: "300px" }}
                        />
                      </div>
                    )}
                  </TabPanel>
                  <TabPanel value={value} index={1} dir={theme.direction}>
                    <div className={classes.qr}>
                      <QRCode
                        style={{ cursor: "pointer" }}
                        onClick={handleDownloadQr}
                        value={seat.id}
                      />
                    </div>
                  </TabPanel>
                </SwipeableViews>
              </>
            )}
          </div>
        </DialogContentText>
        <DialogActions>
          <Button color="secondary" onClick={onClose}>
            Chiudi
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default BeachSelectorDialog;
